import TooltipPortal from './tooltip-portal';

import './tooltip-portal.scss';

export default TooltipPortal;
